if (!customElements.get('tmg-footer-accordion')) {
  customElements.define('tmg-footer-accordion', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.media = matchMedia('(max-width: 749px)');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.active = () => this.dataset.mode === 'all' || this.media.matches;
      this.update = () => {
        this.details.open = !this.active();
        this.summary.tabIndex = this.active() ? 0 : -1;
        this.summary.setAttribute('aria-expanded', this.details.open);
      };
      this.summary.addEventListener('click', (event) => { if (!this.active()) event.preventDefault(); }, options);
      this.details.addEventListener('toggle', () => this.summary.setAttribute('aria-expanded', this.details.open), options);
      this.media.addEventListener('change', this.update, options);
      this.closest('.footer-block').addEventListener('shopify:block:select', () => { this.details.open = true; }, options);
      // Keep newsletter validation and success messages visible after submission.
      this.update();
      if (this.querySelector('.form__message')) this.details.open = true;
    }
    disconnectedCallback() { this.controller.abort(); }
  });
}
